import { render, staticRenderFns } from "./dietaryGuidance.vue?vue&type=template&id=e21eec20&scoped=true"
import script from "./dietaryGuidance.vue?vue&type=script&lang=js"
export * from "./dietaryGuidance.vue?vue&type=script&lang=js"
import style0 from "./dietaryGuidance.vue?vue&type=style&index=0&id=e21eec20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21eec20",
  null
  
)

export default component.exports